import React from 'react';
import { motion } from 'framer-motion';
export function Section10() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="bg-[#0F4226] text-white py-20" data-id="element-28">
      <div className="max-w-3xl mx-auto px-6" data-id="element-29">
        <h2 className="font-sans font-bold text-4xl mb-12 text-center" data-id="element-30">
          10. The Only Question Left
        </h2>

        <div className="font-sans text-xl leading-relaxed space-y-8 mb-12 text-white/90" data-id="element-31">
          <p data-id="element-32">
            Tick populations have expanded into all 48 states. The black-legged
            tick range has grown 45% since 1996. Tick season doesn't wait for
            you to feel ready.
          </p>
          <p data-id="element-33">
            Every day you wait is a day your pet is in the yard, on the trail,
            in the grass without the protection you now know is possible.
          </p>
          <p className="text-2xl font-medium italic text-[#4DC61A]" data-id="element-34">
            Another tick season of background anxiety. Another spring of
            dreading every walk. Another month of the chemical guilt you've been
            carrying.
          </p>
          <p data-id="element-35">
            The cost of not trying FLO is not zero — it's everything you've
            already been paying in stress and compromise.
          </p>
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded my-10" data-id="element-36">
            <p className="text-2xl leading-relaxed text-white" data-id="element-37">
              You've done the research. More than most people ever will. You
              know what's in the products your vet recommends. You know what the
              ancient world knew. You know what 50,000 other pet parents
              discovered before you.
            </p>
            <p className="text-2xl leading-relaxed mt-6 font-semibold text-white" data-id="element-38">
              The only question left is whether you're going to give yourself
              permission to stop searching.
            </p>
          </div>
          <p className="text-center text-2xl italic text-white" data-id="element-39">
            If it doesn't work, you pay nothing.
          </p>
        </div>

        <div className="text-center space-y-8" data-id="element-40">
          <p className="font-sans text-4xl font-bold leading-tight text-white" data-id="element-41">
            Protect your pet the way nature always intended.
          </p>
          <p className="font-sans text-3xl italic text-white/90" data-id="element-42">
            Clip it on. Forget about it. Breathe.
          </p>

          <motion.a href="https://zenessa.shop/products/pet-flea-collar" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-[#4DC61A] text-white font-sans font-bold text-2xl px-12 py-6 rounded-[100px] shadow-2xl transition-all duration-200" data-id="element-43">
            Get FLO Now — 60-Day Risk-Free Guarantee
          </motion.a>

          <p className="text-lg opacity-90 mt-6 text-white/80" data-id="element-44">
            Join 50,000+ pet parents who've already made the switch
          </p>
        </div>

        <div className="mt-16 pt-8 border-t border-white/20 text-center text-sm opacity-75 text-white/70" data-id="element-45">
          <p data-id="element-46">
            Free shipping on all orders • 60-day money-back guarantee • Safe for
            dogs and cats
          </p>
        </div>
      </div>
    </motion.section>;
}